
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.32 4.161l6.202 4.493a.815.815 0 00.954 0l6.202-4.493M2.713 14.211h12.572a.808.808 0 00.556-.219.725.725 0 00.23-.526V4.533a.725.725 0 00-.23-.526.809.809 0 00-.556-.218H2.713a.808.808 0 00-.555.218.725.725 0 00-.23.526v8.933c0 .197.083.386.23.526.147.14.347.218.555.218z","stroke":"currentColor","stroke-width":"1.886","stroke-linecap":"round"}})])
          )
        }
      }
    